<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">

        <div class="form-group" style="margin-top: 30px">
            <a @click="$router.go(-1)" class="btn btn-default">{{ $t('Back') }}</a>
        </div>


        <CRow class="justify-content-md-center">
            <CCol sm="8">
                <CCard>
                    <form v-on:submit.prevent="saveForm()">


                        <CCardHeader>
                            <strong>ویرایش Flow (گردش)   </strong>
                            <!--                        <div class="card-header-actions">-->
                            <!--                            <a-->
                            <!--                                    href="#"-->
                            <!--                                    class="card-header-action"-->
                            <!--                                    rel="noreferrer noopener"-->
                            <!--                                    target="_blank"-->
                            <!--                            >-->
                            <!--                                <small class="text-muted">خروجی اکسل</small>-->
                            <!--                            </a>-->
                            <!--                        </div>-->
                        </CCardHeader>
                        <CCardBody>


                            <CRow>




                                 <CCol sm="12">
                                    <label class="control-label">فرایند   (Process) </label>
                                    <b-form-select v-model="item.process_id" style="direction: ltr">

                                        <b-form-select-option  v-for="(process, processIndex) in processes" :key="processIndex"
                                                               :value="process.id"  >
                                            {{process.title}}
                                        </b-form-select-option>

                                    </b-form-select>
                                </CCol>


<!--                                <CCol sm="12">-->
<!--                                    <label class="control-label">   Issue Type </label>-->
<!--                                    <b-form-select v-model="item.type" style="direction: ltr">-->

<!--                                        <b-form-select-option  v-for="(type, typeIndex) in types" :key="typeIndex"  :style="{color: typeBadgeStyles(type)}"-->
<!--                                                               :value="type.id"  >-->
<!--                                            {{type.title}}-->
<!--                                        </b-form-select-option>-->

<!--                                    </b-form-select>-->
<!--                                </CCol>-->




                                <CCol sm="12">
                                    <CInput
                                            v-model="item.title"
                                            label="عنوان  Flow (گردش) "
                                            placeholder=""
                                    />
                                </CCol>


                                <CCol sm="12">
                                    <CInput
                                            v-model="item.intro"
                                            label="  توضیحات  "
                                            placeholder=""
                                    />
                                </CCol>


                                <!--                                <CCol sm="12">-->
                                <!--                                    <CInput-->
                                <!--                                            v-model="item.default_value"-->
                                <!--                                            label="  مقدار اولیه"-->
                                <!--                                            placeholder=""-->
                                <!--                                    />-->
                                <!--                                </CCol>-->

                            </CRow>


                            <div class="row">
                                <div class="col-xs-12 form-group">
                                    <button class="btn btn-success"> {{ $t('Edit') }}</button>
                                </div>
                            </div>
                        </CCardBody>


                    </form>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }
    };


    export default {
        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                itemId: null,
                register: "",
                due: "",
                account: [],
                item: {
                    title: '',
                    intro: '',
                    type: '',
                    // options: null,
                    // default_value: '',
                    // state: ''
                },

                processeslist: [],
                errors: [],
                processes: [],

                types: [],


            }
        },

        mounted() {
            let app = this;
            let id = app.$route.params.id;
            app.itemId = id;
            axios
                .get(`/api/flows/` + app.$route.params.id, auth)


                .then(function (resp) {
                    console.log('issueType',resp.data)

                    app.item = resp.data.data;
                })
                .catch(function (e) {
                    for (let value of e.response.data.messages_fa) {
                        //                        for (let error of Object.entries(value[1])) {
                        //                            console.log(app.object.entries(app.errors[0]));

                        app.$snotify.warning(value, {
                            timeout: 7000,
                            //                                    showProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true
                        });

                        //                        }
                    }
                });

            this.getTypes()
            this.getProcesses()


        },


        methods: {
            chanegRegister(data) {
                this.item.register_date = data
            },
            chanegdue(data) {
                this.item.due_date = data
                // console.log(this.item.due_date)
            },
            saveForm() {
                var app = this;
                var newItem = app.item;
                // itemId =
                    axios.patch(`/api/flows/` + app.$route.params.id, newItem, auth)


                        .then(function (resp) {
                            // console.log(resp)
                            // app.$router.push({path: '/issueType/list'});
                            app.$router.go(-1);


                        })
                        .catch(
                            e => {

                                app.errors.push(e.response.data.message);
                                for (let value of e.response.data.messages_fa) {
                                    //                        for (let error of Object.entries(value[1])) {
                                    //                            console.log(app.object.entries(app.errors[0]));

                                    app.$snotify.warning(value, {
                                        timeout: 7000,
                                        //                                    showProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true
                                    });

                                    //                        }
                                }

                            }

                        );
            },
            spliceNumber(number) {
                //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

                // $("input[data-type='number']").keyup(function (event) {
                //     var $this = $(this);
                //     var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
                //     $this.val(num2);
                // });
                if (number != null) {
                    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                }
            },
            changeBuyer() {

                var name = this.processeslist.find(x => x.id == this.item.processes_id);
                console.log(name)
                if (name)
                    this.item.buyer = name.first_name + name.last_name

            },




            getProcesses(){
                var app = this;
                axios.get('/api/processList', app.auth)
                    .then(function (response) {
                        app.processes = response.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },




            getTypes(){
                var app = this;
                axios.get('/api/issueTypeList', app.auth)
                    .then(function (response) {
                        app.types = response.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            typeBadgeStyles(issueType){
                if (issueType.type == 1)
                    return '#880e4e'
                else if (issueType.type == 2)
                    return '#f50057'
                else if (issueType.type == 3)
                    return '#8e24aa'
                else if (issueType.type == 4)
                    return '#263238'
                else if (issueType.type == 5)
                    return '#dd2c00'
                else if (issueType.type == 6)
                    return '#00c853'
                else if (issueType.type == 7)
                    return '#0097a7'
                else if (issueType.type == 8)
                    return '#0288d1'
                else if (issueType.type == 9)
                    return '#0208ff'
                else if (issueType.type == 10)
                    return '#eeb600'
                else if (issueType.type == 10)
                    return '#0e8e2e'
                else
                    return '#888888'
            },


        }
    }

</script>
